import { render, staticRenderFns } from "./Xuanze.vue?vue&type=template&id=b80811c8&scoped=true"
import script from "./Xuanze.vue?vue&type=script&lang=js"
export * from "./Xuanze.vue?vue&type=script&lang=js"
import style0 from "./Xuanze.vue?vue&type=style&index=0&id=b80811c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80811c8",
  null
  
)

export default component.exports